import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';
import type { ApplicationRegister, ApplicationRegisterInput } from '/@/types/application-register';

const BASE = () => `${settings.urls.apiDomain}/core/v1/crop-monitoring/application-registers`;

export interface ApplicationRegisterFilters {
    field?: number;
    type?: number;
    recommendation?: number;
    applicationDateGte?: string;
    applicationDateLte?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
}

export interface Paginated<T> {
    count: number;
    results: T[];
}

export async function getApplicationRegisters(
    filters: ApplicationRegisterFilters = {}
): Promise<Paginated<ApplicationRegister>> {
    const params = new URLSearchParams();
    if (filters.field !== undefined) params.append('field', String(filters.field));
    if (filters.type !== undefined) params.append('type', String(filters.type));
    if (filters.recommendation !== undefined) params.append('recommendation', String(filters.recommendation));
    if (filters.applicationDateGte) params.append('application_date__gte', filters.applicationDateGte);
    if (filters.applicationDateLte) params.append('application_date__lte', filters.applicationDateLte);
    if (filters.ordering) params.append('ordering', filters.ordering);
    if (filters.page) params.append('page', String(filters.page));
    if (filters.pageSize) params.append('page_size', String(filters.pageSize));

    const res = await axFetch.get(`${BASE()}/?${params.toString()}`);
    return res.data;
}

export const getApplicationRegisterById = async (id: number): Promise<ApplicationRegister> => {
    const res = await axFetch.get(`${BASE()}/${id}/`);
    return res.data;
};

export const createApplicationRegister = async (data: ApplicationRegisterInput): Promise<ApplicationRegister> => {
    const res = await axFetch.post(`${BASE()}/`, data);
    return res.data;
};

export const updateApplicationRegister = async (
    id: number,
    data: ApplicationRegisterInput
): Promise<ApplicationRegister> => {
    const res = await axFetch.patch(`${BASE()}/${id}/`, data);
    return res.data;
};

export const deleteApplicationRegister = async (id: number): Promise<void> => {
    await axFetch.delete(`${BASE()}/${id}/`);
};
